import { Heart, ShieldCheck, Sparkles, Handshake, Globe, ClipboardCheck } from "lucide-react";
import { VALUES } from "@/data/site";
import { useSite } from "@/i18n/useSite";
import { Reveal } from "./Section";

const ICONS = [Heart, ShieldCheck, Sparkles, Handshake, Globe, ClipboardCheck];
const TILES = ["tile-blue", "tile-sun", "tile-sky", "tile-coral", "tile-mint", "tile-peach"];
const CORNERS = ["corner-tr", "corner-bl", "corner-tr", "corner-bl", "corner-tr", "corner-bl"];

export const ValuesGrid = () => {
  const { VALUES: values } = useSite();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="values-grid">
      {values.map((v, i) => {
        const Icon = ICONS[i];
        const light = TILES[i] === "tile-blue" || TILES[i] === "tile-coral";
        return (
          <Reveal key={i} delay={(i % 3) * 0.08} className="h-full">
            <div className={`p-8 h-full ${TILES[i]} ${CORNERS[i]}`} data-testid={`value-card-${VALUES[i].title.toLowerCase().replace(/\s+/g, "-")}`}>
              <span className={`w-12 h-12 rounded-md flex items-center justify-center ${light ? "bg-white/20 text-white" : "bg-white text-[var(--blue)]"}`}><Icon size={22} /></span>
              <h3 className={`mt-5 text-xl font-semibold ${light ? "!text-white" : "!text-[var(--ink)]"}`}>{v.title}</h3>
              <p className={`mt-2 text-[15px] leading-relaxed ${light ? "text-white/85" : "text-[var(--ink)]/80"}`}>{v.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
};
